import { Component } from "@angular/core";

@Component({
  selector: "app-modal",
  template: `
    <ng-template #modal>
      <ng-content />
    </ng-template>
  `,
  styles: ``,
})
export class Modal {}
